module.exports = __webpack_public_path__ + "media/p2108_archiroid1-0_LP.95275bdf.mp4";